module.exports = { maxWidth: 900, maxHeight: 470 }
